<template>
  <span>
    <b-card :class="cardClass" :style="cardStyle">
      <template #header v-if="title">
        <div class="d-flex justify-content-between" v-b-toggle="title" :disabled="!expandable" >
          <h5 class="mb-0" style="color: #161B4D; font-weight: 700;">{{ title }}</h5>
          <div v-if="expandable">
            <i v-if="expanded" class="bx bxs-down-arrow"></i>
            <i v-else class="bx bxs-right-arrow"></i>
          </div>
        </div>
      </template>
      <b-collapse :id="title" :accordion="title" role="tabpanel" :visible="defaultExpanded">
        <b-table
          ref="table"
          :busy="busy"
          @update:busy="$emit('update:busy', $event)"
          :items="modelMapped"
          :fields="columns['model']"
          show-empty
          :responsive="true"
          thead-class="d-none"
          borderless
          style="padding: 0"
        >
          <template #cell()="data">
            <template v-if="data.field.component">
              <component
                :is="data.field.component"
                v-bind="{ item: data.item }"
                v-on="data.field['componentListeners'] || {}"
              ></component>
            </template>
            <template v-else>{{ data.value }}</template>
          </template>
          <template #empty="scope">
            <Loader :loading="loading" no-axios>
              <div :style="{ maxHeight: `${tableHeight}px` }">
                <p class="my-5">{{ lodash.upperFirst($t("no_data")) }}</p>
              </div>
            </Loader>
          </template>
          <template #emptyfiltered="scope">
            <Loader :loading="loading" no-axios>
              <div :style="{ maxHeight: `${tableHeight}px` }">
                <p class="my-5">
                  {{ lodash.upperFirst($t("search_not_found")) }}
                </p>
              </div>
            </Loader>
          </template>
        </b-table>
      </b-collapse>
    </b-card>
    <!-- <b-card-header header-tag="header" class="p-1" role="tab">
      <b-button block v-b-toggle.accordion variant="info">Revenue</b-button>
    </b-card-header> -->
  </span>
</template>

<script>
import Row from "./custom-row";

export default {
  props: {
    modelMapped: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: undefined,
    },
    cardClass: {
      type: String,
      default: "",
    },
    cardStyle: {
      type: String,
      default: "border-radius: 0; border: none; border-bottom: 1px solid #e5e5e5; margin-bottom: 0;",
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    defaultExpanded: {
      type: Boolean,
      default: true,
    },
  },
  data(){
    return {
      expanded: this.defaultExpanded,
    }
  },
  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === this.title) {
        this.expanded = isJustShown;
      }
    })
  },
  computed: {
    columns() {
      return {
        ["model"]: [
          {
            key: "key",
            label: this.$t("models.key"),
            component: Row,
          },
        ],
      };
    },
    // modelMapped() {
    //   return [
    //     {
    //       key: this.lodash.startCase(this.$t(`delivery_orders.id`)),
    //       value: "this.item.model.id",
    //       class: "row d-print-none",
    //       labelClass: "col-sm-12 col-md-4",
    //       valueClass: "col-sm-12 col-md-8",
    //       showColon: true,
    //       wrapperClass: "d-print-none",
    //     },
    //   ];
    // },
  },
};
</script>

<style scoped>
  .card-body{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  ::v-deep .card-header {
    border: none;
  }

  ::v-deep .table > tbody > tr > td {
    padding: 0.75rem 0.75rem !important;
    overflow-x: hidden;
  }
  /* padding: 0.75rem 0.75rem */
</style>